export const TEXTSIZE = 'textsize';
